import { useQuery } from '@tanstack/react-query';
import { stringify } from 'query-string';
import React from 'react';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { fetcher } from '@dashboard/services/request';
import { formatPrice } from '@dashboard/services/formatting';

const Plans = () => {
  const { token } = useAuth();
  const query = {
    sort: JSON.stringify({
      title: 1,
      version: -1,
    }),
    limit: 50,
  };

  const { data: plans } = useQuery({
    queryKey: ['plans', query],
    queryFn: () => fetcher(`/admin/plans?${stringify(query)}`, token),
  });

  return (
    <div className="pr-4">
      <table className="table-fixed">
        <thead>
          <tr>
            <th className="w-1/4 px-4 py-2">Name</th>
            <th className="w-1/4 px-4 py-2">Merchants</th>
            <th className="w-1/4 px-4 py-2">Monthly price</th>
            <th className="w-1/4 px-4 py-2">Percentage fee</th>
            <th className="w-1/4 px-4 py-2">Version</th>
          </tr>
        </thead>
        <tbody>
          {plans?.map(plan => (
            <tr key={plan.id}>
              <td className="border px-4 py-2">{plan.title}</td>
              <td className="border px-4 py-2">{plan.merchants}</td>
              <td className="border px-4 py-2">{formatPrice({ amount: plan.monthlyPrice })}</td>
              <td className="border px-4 py-2">{plan.percentageFee} %</td>
              <td className="border px-4 py-2">{plan.version}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Plans;
